import supportDashboard from "@/pages/support-user/index.vue";

import SupportUserTicket from "@/pages/admin/support/Parent.vue";
import SupportUserTicketList from "@/pages/admin/support/SupportUserTicket.vue";
import AddSupportUserTicket from "@/pages/admin/support/AddSupportUserTicket.vue";
import SupportUserTicketView from "@/pages/admin/support/SupportUserTicketView.vue";
import { checkifLoggedIn } from "@/utils/functions";

export default [
  {
    path: "support-dashboard",
    name: "support-dashboard",
    component: supportDashboard,
  },
  {
    path: "support-ticket",
    name: "support-ticket",
    component: SupportUserTicket,
    redirect: { name: "support-ticket-list" },
    children: [
      {
        path: "list",
        name: "support-ticket-list",
        component: SupportUserTicketList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
      {
        path: "view/:id",
        name: "support-ticket-view",
        component: SupportUserTicketView,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
      {
        path: "add",
        name: "add-support-ticket",
        component: AddSupportUserTicket,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
    ],
  },
];
